<template>
	<transition 
			appear
			:appear-active-class="$_cldLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow" no-gutters>
			<v-col>
				<v-sheet
						class="customVSheet pa-3"
						:color="$_cldLyt_styleCalendarSheetColor"
						:dark="$_cldLyt_styleCalendarSheetDark"
						:elevation="$_cldLyt_styleCalendarSheetElevation"
						:light="$_cldLyt_styleCalendarSheetLight">
					<v-row align="center" justify="center">
						<v-col cols="auto">
							<v-btn	class="customVBtn"
									icon
									:block="$_cldLyt_styleNavigationButtonBlock"
									:color="$_cldLyt_styleNavigationButtonColor"
									:dark="$_cldLyt_styleNavigationButtonDark"
									:depressed="$_cldLyt_styleNavigationButtonDepressed"
									:elevation="$_cldLyt_styleNavigationButtonElevation"
									:large="$_cldLyt_styleNavigationButtonLarge"
									:light="$_cldLyt_styleNavigationButtonLight"
									:outlined="$_cldLyt_styleNavigationButtonOutlined"
									:rounded="$_cldLyt_styleNavigationButtonRounded"
									:small="$_cldLyt_styleNavigationButtonSmall"
									:text="$_cldLyt_styleNavigationButtonFlat"
									@click="$_cldLyt_previousMonth()">
								<v-icon>keyboard_arrow_left</v-icon>
							</v-btn>
						</v-col>
						<v-col cols="auto">
							<v-card flat>
								<v-row class="mx-1" dense>
									<v-col cols="auto">
										<span v-text="$_cldLyt_formatMonth()" />
									</v-col>
								</v-row>
							</v-card>
						</v-col>
						<v-col cols="auto">
							<v-btn	class="customVBtn"
									icon
									@click="$_cldLyt_nextMonth()">
								<v-icon>keyboard_arrow_right</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-calendar
									class="customVCalendar"

									type="month"

									v-model="$store.state.page.calendar.date"
									:now="today_"

									:color="$_cldLyt_styleCalendarColor"
									:dark="$_cldLyt_styleCalendarDark"
									:light="$_cldLyt_styleCalendarLight"
									
									:event-margin-bottom="3">
								<template v-slot:day="day">
									<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
										<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
											<template v-if="$_cldLyt_checkDate(contentVals, day)">
												<v-sheet
														:key="contentKey"
														color="transparent">
													<v-row no-gutters>
														<v-col>
															<v-menu	bottom offset-y>
																<template v-slot:activator="{ on }">
																	<v-btn	class="customVBtn"
																			x-small tile
																			:color="$_cldLyt_randomcolor(contentKey)"
																			:block="$_cldLyt_styleEventButtonBlock"
																			:dark="$_cldLyt_styleEventButtonDark"
																			:depressed="$_cldLyt_styleEventButtonDepressed"
																			:elevation="$_cldLyt_styleEventButtonElevation"
																			:light="$_cldLyt_styleEventButtonLight"
																			:outlined="$_cldLyt_styleEventButtonOutlined"
																			:rounded="$_cldLyt_styleEventButtonRounded"
																			:text="$_cldLyt_styleEventButtonFlat"
																			v-on="on">
																		<span	class="customVCalendarButtonText overline"
																				v-text="$_cldLyt_formatEventTitle(contentVals, day)" />
																	</v-btn>
																</template>
																<v-card tile>
																	<v-row class="px-4" dense>
																		<v-col cols="auto">
																			<span	class="overline"
																					v-text="formatTimestamp(contentVals.startDate, 'YYYY-MM-DD')" />
																		</v-col>
																		<v-col cols="auto">-</v-col>
																		<v-col cols="auto">
																			<span	class="overline"
																					v-text="formatTimestamp(contentVals.endDate, 'YYYY-MM-DD')" />
																		</v-col>
																	</v-row>
																	<template v-if="!isFalse($_cldLyt_langContentTitle(contentVals))">
																		<v-card-title>
																			<span	class="body-1"
																					v-html="$_cldLyt_langContentTitle(contentVals)" />
																		</v-card-title>
																	</template>
																	<template v-if="!isFalse($_cldLyt_langContentText(contentVals))">
																		<v-card-text class="bottom_">
																			<span	class="caption markdown"
																					v-html="marked($_cldLyt_langContentText(contentVals))" />
																		</v-card-text>
																	</template>
																	<v-card-actions>
																		<v-row dense>
																			<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																				<v-col :key="actionButtonKey" cols="auto">
																					<v-btn	class="customVBtn"
																							:block="$_cldLyt_styleActionButtonBlock"
																							:color="$_cldLyt_styleActionButtonColor"
																							:dark="$_cldLyt_styleActionButtonDark"
																							:depressed="$_cldLyt_styleActionButtonDepressed"
																							:elevation="$_cldLyt_styleActionButtonElevation"
																							:large="$_cldLyt_styleActionButtonLarge"
																							:light="$_cldLyt_styleActionButtonLight"
																							:outlined="$_cldLyt_styleActionButtonOutlined"
																							:rounded="$_cldLyt_styleActionButtonRounded"
																							:small="$_cldLyt_styleActionButtonSmall"
																							:text="$_cldLyt_styleActionButtonFlat"
																							@click="openLink(actionButtonVals.link)"
																							v-text="$_cldLyt_langActionButtonTitle(actionButtonVals)" />
																				</v-col>
																			</template>
																		</v-row>
																	</v-card-actions>
																</v-card>
															</v-menu>
														</v-col>
													</v-row>
												</v-sheet>
											</template>
										</template>
									</template>
								</template>
							</v-calendar>
						</v-col>
					</v-row>
				</v-sheet>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'CalendarLayout',
		props: {
			inits: Object,
			contents: Object
		},
		data() {
			return {
				today_:null,
				colors_: {}
			}
		},
		computed: {
			// state
			$_cldLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// info
			$_cldLyt_infoInterval() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'interval')
			},
			// lang
			// (content)
			$_cldLyt_langContentEventTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.eventTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_cldLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_cldLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_cldLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_cldLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_cldLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_cldLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_cldLyt_styleCalendarSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'calendarSheet')
			},
			$_cldLyt_styleCalendarSheetColor() {
				const self_ = this;
				const calendarSheet_ = self_.$_cldLyt_styleCalendarSheet;
				if(self_.isFalse(calendarSheet_)) { return null }
				return self_.getStylesVal(calendarSheet_.color)
			},
			$_cldLyt_styleCalendarSheetDark() {
				const self_ = this;
				const calendarSheet_ = self_.$_cldLyt_styleCalendarSheet;
				if(self_.isFalse(calendarSheet_)) { return null }
				return self_.getStylesVal(calendarSheet_.dark)
			},
			$_cldLyt_styleCalendarSheetElevation() {
				const self_ = this;
				const calendarSheet_ = self_.$_cldLyt_styleCalendarSheet;
				if(self_.isFalse(calendarSheet_)) { return null }
				return self_.getStylesVal(calendarSheet_.elevation)
			},
			$_cldLyt_styleCalendarSheetLight() {
				const self_ = this;
				const calendarSheet_ = self_.$_cldLyt_styleCalendarSheet;
				if(self_.isFalse(calendarSheet_)) { return null }
				return self_.getStylesVal(calendarSheet_.light)
			},
			$_cldLyt_styleCalendar() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'calendar')
			},
			$_cldLyt_styleCalendarColor() {
				const self_ = this;
				const carousel_ = self_.$_cldLyt_styleCalendar;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.color)
			},
			$_cldLyt_styleCalendarDark() {
				const self_ = this;
				const carousel_ = self_.$_cldLyt_styleCalendar;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.dark)
			},
			$_cldLyt_styleCalendarLight() {
				const self_ = this;
				const carousel_ = self_.$_cldLyt_styleCalendar;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.light)
			},
			$_cldLyt_styleNavigationButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'navigationButton')
			},
			$_cldLyt_styleNavigationButtonBlock() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.block)
			},
			$_cldLyt_styleNavigationButtonColor() {
				const self_ = this;
				const navigationButton_ =self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.color)
			},
			$_cldLyt_styleNavigationButtonDark() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.dark)
			},
			$_cldLyt_styleNavigationButtonDepressed() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.depressed)
			},
			$_cldLyt_styleNavigationButtonElevation() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.elevation)
			},
			$_cldLyt_styleNavigationButtonFlat() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.flat)
			},
			$_cldLyt_styleNavigationButtonLarge() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.large)
			},
			$_cldLyt_styleNavigationButtonLight() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.light)
			},
			$_cldLyt_styleNavigationButtonOutlined() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.outlined)
			},
			$_cldLyt_styleNavigationButtonRounded() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.rounded)
			},
			$_cldLyt_styleNavigationButtonSmall() {
				const self_ = this;
				const navigationButton_ = self_.$_cldLyt_styleNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.small)
			},
			$_cldLyt_styleEventButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'eventButton')
			},
			$_cldLyt_styleEventButtonBlock() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.block)
			},
			$_cldLyt_styleEventButtonDark() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.dark)
			},
			$_cldLyt_styleEventButtonDepressed() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.depressed)
			},
			$_cldLyt_styleEventButtonElevation() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.elevation)
			},
			$_cldLyt_styleEventButtonFlat() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.flat)
			},
			$_cldLyt_styleEventButtonLight() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.light)
			},
			$_cldLyt_styleEventButtonOutlined() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.outlined)
			},
			$_cldLyt_styleEventButtonRounded() {
				const self_ = this;
				const replyButton_ = self_.$_cldLyt_styleEventButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.rounded)
			},
			$_cldLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_cldLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_cldLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_cldLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_cldLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_cldLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_cldLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_cldLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_cldLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_cldLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_cldLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_cldLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_cldLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_cldLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_cldLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_cldLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		created() {
			const self_ = this;
			
			self_.today_ = self_.formatDate(new Date(), 'YYYY-MM-DD hh:mm:ss')
		},
		methods: {
			$_cldLyt_checkDate(contentVals, day) {
				const self_ = this;

				const start_ = self_.formatTimestamp(contentVals.startDate, 'YYYY-MM-DD')
				const end_ = self_.formatTimestamp(contentVals.endDate, 'YYYY-MM-DD')

				return start_ <= day.date && end_ >= day.date
			},
			$_cldLyt_nextMonth() {
				const self_ = this;

				const calendar_ = self_.getPageState('calendar')
				const date_ = calendar_.date

				const next_ = self_.moment(date_).add(1, 'month')

				calendar_.date = self_.formatDate(next_, 'YYYY-MM-DD hh:mm:ss');

				self_.setPageState('calendar', calendar_)
			},
			$_cldLyt_previousMonth() {
				const self_ = this;

				const calendar_ = self_.getPageState('calendar')
				const date_ = calendar_.date

				const previous_ = self_.moment(date_).subtract(1, 'month')

				calendar_.date = self_.formatDate(previous_, 'YYYY-MM-DD hh:mm:ss');

				self_.setPageState('calendar', calendar_)
			},
			$_cldLyt_formatMonth() {
				const self_ = this;

				const calendar_ = self_.getPageState('calendar')
				const date_ = calendar_.date

				return self_.formatDate(date_, 'YYYY MMMM')
			},
			$_cldLyt_formatEventTitle(contentVals, day) {
				const self_ = this;

				const start_ = self_.formatTimestamp(contentVals.startDate, 'YYYY-MM-DD')

				if(start_ == day.date) { return self_.$_cldLyt_langContentEventTitle(contentVals) }
				else { return null }
			},
			$_cldLyt_randomcolor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				if(!self_.isFalse(self_.contents[key].color)) {
					self_.colors_[key] = self_.contents[key].color;
				} else {
					self_.colors_[key] = self_.getChanceColor()
				}
				
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.bottom_ {
		padding-top: 0;
	}
</style>
